<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center">
                <h1 class="">Coralstone Blog</h1>
                <p class="">Get the update of happenings, financial advice, tips and insight from our companies</p>
            </div>
        </div>
    </section>

    <!-- blog post section -->
    <section class="blog-post">
      <div class="container">
          <div class="row">
            <div class="col-md-6 col-lg-4">
              <a @click="$router.push({ name: 'BlogPost'})" href="#">
                <div class="card">
                  <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                  <div class="card-body">
                    <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                    <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                    <div class="footer">
                      <div class="footer-wrapper d-flex justify-content-between">
                        <div class="footer-text">
                          <img src="img/avartar.svg" alt="">
                          <small class="date">Admin on 22 December 2019</small>
                        </div>
                        <div>
                          <small class="read">3 Mins Read</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4">
              <div class="card">
                <img src="/img/blog-post-image.svg" class="card-img-top" alt="">
                <div class="card-body">
                  <h5 class="card-title">Facts About Dividends You Need To Know</h5>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Feugiat faucibus elit suspendisse semper mauris, tristique tristique sed. Ut id.</p>
                  <div class="footer">
                    <div class="footer-wrapper d-flex justify-content-between">
                      <div class="footer-text">
                        <img src="img/avartar.svg" alt="">
                        <small class="date">Admin on 22 December 2019</small>
                      </div>
                      <div>
                        <small class="read">3 Mins Read</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" href="#" aria-label="Previous">
                  <span class="fas fa-angle-left"  aria-hidden="true"></span>
                </a>
              </li>
              <li class="page-item active"><a class="page-link" href="#">1</a></li>
              <li class="page-item"><a class="page-link" href="#">2</a></li>
              <li class="page-item"><a class="page-link" href="#">3</a></li>
              <li class="page-item">
                <a class="page-link" href="#" aria-label="Next">
                  <span class="fas fa-angle-right" aria-hidden="true"></span>
                </a>
              </li>
            </ul>
          </nav>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  },
  mounted() {
    const heroHeader = document.querySelector('.hero-header');

    //let windowHeight = window.innerHeight;
    heroHeader.offsetHeight;
    console.log(heroHeader.offsetHeight);
    
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/blog-hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
      }
  }

  // blog post styles
  .blog-post {
    padding: 3rem 0 6rem;

    a {
      text-decoration: none;
      color: #2c3e50;
    }

    .card {
      margin-bottom: 2rem;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .card-title {
        font-weight: bold;
        font-size: 21px;
        line-height: 25px;
        color: #171F4A
      }

      .footer {
        border-top: 2px solid #F1F3F4;
        margin-top: 4rem;
        padding-top: 1rem;

        .footer-wrapper {
          align-items: center;

          .footer-text {
            img {
              margin-right: 0.6rem;
            }

            // .read {
              
            // }
          }

          small {
            font-size: 80%;
          }
        }
      }
    }

    .pagination {
      margin-top: 2rem;
    }
  }

  
  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 64px;
                line-height: 96px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }
    .blog-post {
      padding: 2rem 0 4rem;

      .card {

        .footer {

          .footer-wrapper {

            small {
              font-size: 64%;
            }
          }
        }
      }
    }
  }

  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 52px;
                line-height: 76px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 5rem;
            }
        }
    }

    .blog-post {
      padding: 0 0 4rem;

      .card {

        .card-title {
          font-size: 20px;
        }

        .footer {

          .footer-wrapper {

            small {
              font-size: 75%;
            }
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/blog-hero-header-mobile.svg");
        //background-size: contain;
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 42px;
                line-height: 57px;
            }

            p {
                font-size: 20px;
                line-height: 32px;
                padding: 0 3rem;
            }
        }
    }

    h3 {
      font-size: 32px;
      text-align: center;
    }
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    .blog-post {
      padding: 0 0 2rem;
      margin-top: -1rem;
    }
    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }
  }

     @media (max-width: 320px) {
      .hero-header {
          //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
          padding-top: 6rem;

          .description {

              h1 {
                  font-size: 35px;
              }

              p {
                  font-size: 17px;
                  padding: 0 2rem;
              }
          }
      }
      
    }


</style>

